module.exports = __webpack_public_path__ + "static/media/eatBurgers.cc76322e.png";